// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/application/application.less
// module id = 2995
// module chunks = 0 2